import React from "react";

const MatchScores = ({ score, winner }) => {
  return (
    <div className="cl_score">
      <span
        className={`score ${
          winner?.split("-")[0] > winner?.split("-")[1] ? "bold" : ""
        }`}
      >
        {score?.split("-")[0]}
      </span>{" "}
      {/* <span className="ds_2 d_none d_lg_inline"> : </span> */}
      <span
        className={`score ${
          winner?.split("-")[1] > score?.split("-")[0] ? "bold" : ""
        }`}
      >
        {score?.split("-")[1]}
      </span>
    </div>
  );
};

export default MatchScores;
